import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const AccountViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/accountViewPage'
    )
);

const EscalationsTab = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/tabs/archive-view/escalationsTab'
    )
);

const OdeHistoryTab = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/tabs/archive-view/odeHistoryTab'
    )
);

const CrrTab = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/tabs/archive-view/crrTab'
    )
);

const LimitationsLogTab = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/tabs/archive-view/limitationsLogTab'
    )
);

const UserEventsTab = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/account-view/tabs/archive-view/userEventsTab'
    )
);

export const accountViewRoutes: PageRouter[] = [
  {
    name: 'overview',
    path: '/overview/:tabType?/:tableEntityType?/:recordId?',
    component: AccountViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'advanced-details',
    path: '/advanced-details',
    component: AccountViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'kyc',
    path: '/kyc',
    component: AccountViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'activity',
    path: '/activity',
    component: AccountViewPage,
    exact: false,
    tabs: [
      {
        name: 'escalations',
        displayName: 'Escalations',
        path: '/escalations',
        component: EscalationsTab,
        exact: true
      },
      {
        name: 'escalations-with-id',
        displayName: 'Escalations',
        path: '/escalations/:escalationId',
        component: EscalationsTab,
        exact: true,
        hideFromMenu: true
      },
      {
        name: 'ode-history',
        displayName: 'ODE History',
        path: '/ode-history',
        component: OdeHistoryTab,
        exact: true
      },
      {
        name: 'limitations-log',
        displayName: 'Limitations log',
        path: '/limitations-log',
        component: LimitationsLogTab,
        exact: true
      },
      {
        name: 'crr-history',
        displayName: 'CRR History',
        path: '/crr-history',
        component: CrrTab,
        exact: true
      },
      {
        name: 'user-events',
        displayName: 'User events',
        path: '/user-events',
        component: UserEventsTab,
        exact: true
      }
    ]
  },
  {
    name: 'file-attachments',
    path: '/file-attachments',
    component: AccountViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'payments',
    path: '/payments',
    component: AccountViewPage,
    exact: true,
    tabs: []
  }
];
